<div class="row h-100 gy-3">
  <div class="col">
    <div class="p-3 bg-white border d-flex flex-column h-100 overflow-hidden rounded-4 shadow-sm">
      <div class="d-flex align-items-center mb-3">
        <h2 class="mb-0">Addendums</h2>
        <button class="btn btn-primary btn-h42 ms-auto" type="button" (click)="openAddOptionModal()">
          <i class="bi bi-plus fs-20"></i>
          Add Addendums
        </button>
      </div>
      <div class="accordion-treeview overflow-y-auto h-100 pe-3 me-n3 d-flex flex-column gap-3">
        <div class="d-flex flex-column gap-3">
          @for (dealAddendum of dealsOptions(); track dealAddendum.id; let i = $index) {
            <div
              (click)="onAddendumSelect(dealAddendum.id)"
              class="border rounded-4 overflow-hidden p-3 cursor-pointer position-relative card-header-addendum"
              [class.selected-addendum]="dealAddendum.id === selectedAddendumId() && this.selectedProductId() === null"
              [class.addendum-expanded]="dealAddendum.isExpanded"
            >
              <div class="d-flex align-items-center gap-2">
                <div class="flex-fill">
                  <deal-addendum-preview
                    (click)="$event.stopPropagation(); onAddendumSelect(dealAddendum.id)"
                    class="w-100 d-flex align-items-center"
                    [dealAddendum]="dealAddendum"
                    (onChanges)="onOptionChanges()"
                  ></deal-addendum-preview>
                </div>
                <span class="d-flex gap-2 align-items-center">
                  <span
                    class="bg-info-subtle arrow-addendum wh-28 d-inline-flex rounded-2 d-flex-center"
                    type="button"
                    (click)="$event.stopPropagation(); dealAddendum.isExpanded = !dealAddendum.isExpanded"
                  >
                    @if (dealAddendum.isExpanded) {
                      <i class="bi bi-chevron-down fs-18 lh-1"></i>
                    } @else {
                      <i class="bi bi-chevron-right fs-18 lh-1"></i>
                    }
                  </span>
                </span>
              </div>
              @if (dealAddendum.isExpanded) {
                <div class="d-block">
                  <deal-addendum-options
                    [selectedProductId]="selectedProductId()"
                    [dealAddendum]="dealAddendum"
                    [modelId]="modelId()"
                    [elevationId]="elevationId()"
                    (onChanges)="onOptionChanges()"
                    (onProductSelected)="onAddendumProductSelect(dealAddendum.id, $event)"
                    (onKitProductSelected)="onAddendumProductSelect(dealAddendum.id, $event, true)"
                  ></deal-addendum-options>
                </div>
              }
              @if (dealAddendum.createdByUserFullName) {
                <div class="text-end mt-2">
                  <span class="fs-12 text-muted">
                    Created By <span class="fw-600">{{ dealAddendum.createdByUserFullName }}</span> on
                    <span class="fw-600">{{ dealAddendum.createdAt | date: 'MM/dd/yyyy' }}</span>
                  </span>
                </div>
              }
            </div>
          }
        </div>
        @if (dealsOptions().length === 0) {
          <div class="d-flex flex-column gap-2 align-items-center justify-content-center h-100">
            <p class="text-muted">No addendums found for this lot</p>
          </div>
        }
      </div>
    </div>
  </div>

  @if (showAddendumDetails() || showOptionDetails()) {
    <div class="col-xl1-3 h-100">
      @if (showAddendumDetails()) {
        <deal-addendum-details
          [dealAddendum]="selectedAddendum()!"
          (onChanges)="onOptionChanges()"
        ></deal-addendum-details>
      }
      @if (showOptionDetails()) {
        <deal-addendum-option-details
          [dealAddendum]="selectedAddendum()!"
          [addendumProductId]="selectedProductId()!"
          (onChanges)="onOptionChanges()"
          [isKitLinkedProduct]="selectedKitProductId === selectedProductId()"
        ></deal-addendum-option-details>
      }
    </div>
  }
</div>
